import { createAppKit } from '@reown/appkit/vue'

import { base, baseSepolia } from '@reown/appkit/networks'
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'
import { env } from '@/env.ts'
import { http } from '@wagmi/core'
import { createClient } from 'viem'

export const metadata = {
  name: 'Lingo dev',
  description: 'Lingo token',
  url: env.app.url, // origin must match your domain & subdomain
  icons: ['https://avatars.githubusercontent.com/u/37784886'],
}

export const networks = [env.app.isProd ? base : baseSepolia]

export const wagmiAdapter = new WagmiAdapter({
  projectId: env.reown.projectId,
  networks,
  client({ chain }) {
    return createClient({ chain, transport: http(env.contracts.rpcEndpoint) })
  },
})

export const config = wagmiAdapter.wagmiConfig

export async function init() {
  createAppKit({
    defaultAccountTypes: { eip155: 'smartAccount' },
    enableAuthLogger: true,
    adapters: [wagmiAdapter],
    networks: [env.app.isProd ? base : baseSepolia],
    metadata,
    projectId: env.reown.projectId,
    features: {
      analytics: true, // Optional - defaults to your Cloud configuration
    },
  })
}
